module.exports = __webpack_public_path__ + "static/media/bg-prescriber-hero-mobile.cef27a94.jpg";